import script from "./AdminLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminLayout.vue?vue&type=script&setup=true&lang=js"

import "./AdminLayout.vue?vue&type=style&index=0&id=5287d5e3&lang=less&scoped=true"

import exportComponent from "/Users/timetravel/code/energy-storage-intelligence/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5287d5e3"]])

export default __exports__